import { render, staticRenderFns } from "./wxFileView.vue?vue&type=template&id=5fcb326a&"
import script from "./wxFileView.vue?vue&type=script&lang=js&"
export * from "./wxFileView.vue?vue&type=script&lang=js&"
import style0 from "./wxFileView.vue?vue&type=style&index=0&id=5fcb326a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports